const zh = {
	license: {
		LicenseAgent: '许可证列表',
		onLineActivate: '在线激活',
		offLineActivate: '离线激活',
		plan: '计划',
		SerialNumberList: '激活码',
		ExpirationTime: '过期时间',
		EffictiveTime: '生效时间',
		viewClientID: '查看HWID',
		Description: '描述',
		deactivate: '停用',
		sortFile: '拖拽文件至此处或者手动选择',
		selectFile: '选择文件',
		DelteteTip: '您确定要停用该许可证吗？',
		Status: '状态',
		MicroFrameManage: '集群管理',
		License: '许可证',
		Service: '服务',
		LicenseList: '许可证列表',
		Name: '名称',
		CustomerName: '自定义名称',
		Service: '服务',
		HWID: 'HWID',
		Active_Deactive: '活动/停用',
		Action: '操作',
		AddLicense: '添加许可证',
		required: '必填',
		Permanent: '永久',
		Customname: '自定义名称',
		Delete: '删除',
		Detail: '详情',
		BindedService: '绑定服务',
		nodata: '暂无数据'
	},
	service: {
		ServiceList: '服务列表',
		Name: '名称',
		Version: '版本',
		Checksum: 'Checksum',
		Description: '描述',
		Action: '操作',
		VersionHistory: '版本历史',
		required: '必填',
		Delete: '删除',
		DeleteTip: '您确定要删除',
		AddService: '添加服务',
		EditService: '编辑服务',
		Plan: '计划'
	}
}

export default zh


// WEBPACK FOOTER //
// ./src/js/i18n/zh.js